import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo, images } from '../data/mock';
import { ArrowLeft } from 'lucide-react';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-[#F5F7F2]">
      {/* Simple Header */}
      <header className="bg-[#1E4D2B] py-6">
        <div className="container mx-auto px-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white hover:text-[#FFD700] transition-colors"
          >
            <img
              src={images.logo}
              alt="MeisterGrün Logo"
              className="h-[35px] w-auto"
            />
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-4 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#2D5F3A] hover:text-[#1E4D2B] transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        <div className="max-w-3xl">
          <h1 className="text-4xl font-bold text-[#1E4D2B] mb-8">Impressum</h1>

          <div className="bg-white rounded-[32px] p-8 shadow-sm space-y-8">
            <section>
              <h2 className="text-xl font-semibold text-[#1E4D2B] mb-4">
                Angaben gemäß § 5 TMG
              </h2>
              <p className="text-[#2D5F3A] leading-relaxed">
                {companyInfo.name}<br />
                {companyInfo.address.street}<br />
                {companyInfo.address.zip} {companyInfo.address.city}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1E4D2B] mb-4">
                Kontakt
              </h2>
              <p className="text-[#2D5F3A] leading-relaxed">
                Telefon: {companyInfo.phone}<br />
                E-Mail: {companyInfo.email}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1E4D2B] mb-4">
                Umsatzsteuer-ID
              </h2>
              <p className="text-[#2D5F3A] leading-relaxed">
                Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
                <span className="italic text-[#807979]">[Steuernummer hier einfügen]</span>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1E4D2B] mb-4">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p className="text-[#2D5F3A] leading-relaxed">
                <span className="italic text-[#807979]">[Name des Verantwortlichen]</span><br />
                {companyInfo.address.street}<br />
                {companyInfo.address.zip} {companyInfo.address.city}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1E4D2B] mb-4">
                Streitschlichtung
              </h2>
              <p className="text-[#2D5F3A] leading-relaxed">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
                <a
                  href="https://ec.europa.eu/consumers/odr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#1E4D2B] hover:underline"
                >
                  https://ec.europa.eu/consumers/odr
                </a>
                <br /><br />
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#1E4D2B] mb-4">
                Haftung für Inhalte
              </h2>
              <p className="text-[#2D5F3A] leading-relaxed">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
                nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
                Tätigkeit hinweisen.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Impressum;
